/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Deck } from './Deck';
import {
    DeckFromJSON,
    DeckFromJSONTyped,
    DeckToJSON,
    DeckToJSONTyped,
} from './Deck';

/**
 * 
 * @export
 * @interface Ship
 */
export interface Ship {
    /**
     * The name of the ship
     * @type {string}
     * @memberof Ship
     */
    name?: string;
    /**
     * The ship code
     * @type {string}
     * @memberof Ship
     */
    code?: string;
    /**
     * The ship configuration code
     * @type {string}
     * @memberof Ship
     */
    configCode?: string;
    /**
     * URL leading to the image of the ship
     * @type {string}
     * @memberof Ship
     */
    imageUrl?: string;
    /**
     * List of decks
     * @type {Array<Deck>}
     * @memberof Ship
     */
    decks?: Array<Deck>;
}

/**
 * Check if a given object implements the Ship interface.
 */
export function instanceOfShip(value: object): value is Ship {
    return true;
}

export function ShipFromJSON(json: any): Ship {
    return ShipFromJSONTyped(json, false);
}

export function ShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ship {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'configCode': json['configCode'] == null ? undefined : json['configCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'decks': json['decks'] == null ? undefined : ((json['decks'] as Array<any>).map(DeckFromJSON)),
    };
}

export function ShipToJSON(json: any): Ship {
    return ShipToJSONTyped(json, false);
}

export function ShipToJSONTyped(value?: Ship | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'configCode': value['configCode'],
        'imageUrl': value['imageUrl'],
        'decks': value['decks'] == null ? undefined : ((value['decks'] as Array<any>).map(DeckToJSON)),
    };
}

